import React from 'react';
import Alert, { AlertProps } from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Typography from '@mui/material/Typography';
import { AppAlertOptions } from './alert.types';

export interface AppAlertProps extends AppAlertOptions, AlertProps {
  children: React.ReactNode;
}

function AppAlert({ children, title, withMain = false, ...alertProps }: AppAlertProps) {
  const { sx, ...restMuiAlertProps } = alertProps;
  return (
    <AppAlertWrapper withMain={withMain}>
      <Alert
        data-id="app-alert"
        sx={{
          borderRadius: 0,
          maxHeight: '250px',
          alignItems: 'center',
          '& .MuiAlert-action': {
            padding: 0,
          },
          ...sx,
        }}
        variant="filled"
        {...restMuiAlertProps}
      >
        {title ? <AlertTitle>{title}</AlertTitle> : null}
        {withMain ? (
          <Typography component="h1" variant="body1" id="main-content">
            {children}
          </Typography>
        ) : (
          children
        )}
      </Alert>
    </AppAlertWrapper>
  );
}

function AppAlertWrapper({ withMain, children }: { withMain: boolean; children: React.ReactNode }) {
  return <>{withMain ? <main>{children}</main> : children}</>;
}

export default AppAlert;
